import { create } from 'zustand';

interface RandomnessModalStore {
	isOpen: boolean;
	openRandomnessModal: () => void;
	closeRandomnessModal: () => void;
}

export const useRandomnessModalStore = create<RandomnessModalStore>((set) => ({
	isOpen: false,
	openRandomnessModal: () => set({ isOpen: true }),
	closeRandomnessModal: () => set({ isOpen: false }),
}));
